import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(e, fallback = "Une erreur est survenue. Réessayez.") {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    return e?.message || fallback;
}

export const fmtEUR = (cents, currency = "EUR") =>
    new Intl.NumberFormat("fr-FR", { style: "currency", currency }).format((cents || 0) / 100);

export const fmtDate = (d) =>
    d ? new Intl.DateTimeFormat("fr-FR", { dateStyle: "medium", timeStyle: "short" }).format(new Date(d)) : "—";

export const mediaUrl = (path) =>
    path?.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path;

export const focalStyle = (img) =>
    img && img.focal_x != null ? { objectPosition: `${img.focal_x}% ${img.focal_y ?? 50}%` } : undefined;

/** Lien profond canonique de retour vers l'application BODYCOACHIA (contrat fédération).
 * Un clic utilisateur sur ce scheme ouvre l'application installée (Android/iOS) —
 * window.close()/history.back() ne ferment pas Chrome : ne jamais les substituer. */
export const appReturnUrl = (status) => `frontend://review-return?status=${status}`;

/** Conversion canonique texte brut → HTML (migration douce vers l'éditeur riche). */export const plainToHtml = (t) =>
    (t || "")
        .split("\n\n")
        .map((p) => p.trim())
        .filter(Boolean)
        .map((p) => `<p>${p.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>")}</p>`)
        .join("");

/** Extraction canonique du texte brut depuis le HTML de l'éditeur (compatibilité
 * des champs historiques : chaque bloc devient une ligne). */
export const htmlToPlain = (h) => {
    const el = document.createElement("div");
    el.innerHTML = h || "";
    el.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
    el.querySelectorAll("p,li,h1,h2,h3,blockquote,ul,ol").forEach((n) => n.append("\n"));
    return (el.textContent || "").replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
};
